module.exports = "./img/5690dfd2abbe0ed1dcd3d676d4d65f4f.jpg";